import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '../ui';
import { usePortal } from '../PortalAuth';
import { canSee } from '../shells/nav';
import EsponentiTab from '../people/EsponentiTab';
import { NegativitaBody } from './NegativitaPage';

const TABS = [['esponenti', 'Esponenti (soci e dirigenti)', 'people'], ['negativita', 'Negatività persone fisiche', 'negativita']];

export default function PeoplePage() {
  const { user } = usePortal();
  const [params, setParams] = useSearchParams();
  const tabs = TABS.filter(([, , sec]) => canSee(user, sec));
  const tab = tabs.find(([id]) => id === params.get('tab'))?.[0] || tabs[0]?.[0];
  return (
    <div data-testid="people-page">
      <PageHeader kicker="Persone · esponenti e persone fisiche" title="Ricerca persone" />
      <div className="flex gap-1 border-b border-[#1F242C] mb-6 overflow-x-auto whitespace-nowrap" role="tablist">
        {tabs.map(([id, label]) => (
          <button key={id} role="tab" aria-selected={tab === id} onClick={() => setParams({ tab: id })} data-testid={`people-tab-btn-${id}`}
            className={`px-4 h-10 text-sm border-b-2 -mb-px transition-colors ${tab === id ? 'border-[#D4AF37] text-[#F2F2F2]' : 'border-transparent text-[#7A7F87] hover:text-[#F2F2F2]'}`}>{label}</button>
        ))}
      </div>
      {tab === 'esponenti' && <EsponentiTab />}
      {tab === 'negativita' && <NegativitaBody />}
    </div>
  );
}
